import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Umzugsservice",
    description: "Unser professioneller Umzugsservice in Augsburg und Umgebung garantiert einen stressfreien Wohnungswechsel. Wir übernehmen den sicheren Transport Ihrer Möbel, bieten flexible Terminplanung und sorgen für eine reibungslose Abwicklung. Verlassen Sie sich auf unsere jahrelange Erfahrung, transparente Preise und unseren umfassenden Versicherungsschutz für einen entspannten Umzug.",
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_600/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df932922ae9c1fe6eaa1.jpg",
    path: "/umzugsservice"
  },
  {
    title: "Möbelmontage",
    description: "Fachgerechte und präzise Möbelmontage für alle Hersteller und Systeme. Ob Neukauf, Umzug oder Büroeinrichtung – unsere erfahrenen Monteure bauen Ihre Schränke, Küchen und Regale schnell, sauber und millimetergenau auf. Wir ersparen Ihnen Zeit und Nerven und garantieren einen stabilen, sicheren Aufbau.",
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_600/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df9350387f29d144e356.jpg",
    path: "/moebelmontage"
  },

  {
    title: "Bodenbelag (Laminat, Vinyl)",
    description: "Hochwertige Verlegung von Laminat- und Vinylböden für eine moderne Raumgestaltung. Wir bieten eine fachgerechte Untergrundvorbereitung, exakten Zuschnitt und eine fugenlose Verlegung inklusive Trittschalldämmung und Sockelleisten. Profitieren Sie von langlebigen, optisch ansprechenden Böden.",
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_600/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6949609f83fecfaac9e03033.jpg",
    path: "/bodenbelag"
  },
  {
    title: "Lichtinstallation",
    description: "Professionelle Lichtinstallationen für ein perfektes Ambiente in jedem Raum. Wir montieren Deckenlampen, LED-Spots, Außenbeleuchtung und smarte Lichtsysteme sicher und fachgerecht. Mit der richtigen Beleuchtungsplanung setzen wir Ihr Zuhause optimal in Szene und sorgen gleichzeitig für höchste elektrische Sicherheit.",
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_600/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/69370c2d2ec4f5960a9a42f1.jpg",
    path: "/lichtinstallation"
  },
  {
    title: "Pflasterarbeiten",
    description: "Robuste und optisch ansprechende Pflasterarbeiten für Einfahrten, Terrassen und Gartenwege. Wir übernehmen den fachgerechten Erdaushub, den Unterbau und die präzise Verlegung von Natur- und Betonsteinen. Unsere langlebigen Pflasterflächen überzeugen durch hohe Belastbarkeit, perfekte Entwässerung und ein makelloses Fugenbild.",
    image: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_600/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6946e67759a0a60a8a0e474a.jpg",
    path: "/pflasterarbeiten"
  }
];

const Services = () => {
  return (
    <section id="leistungen" className="py-20 bg-neutral-50 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <span className="font-semibold text-primary uppercase tracking-wider text-sm">Unsere Leistungen</span>
          <h2 className="font-heading text-3xl md:text-5xl mt-2 mb-4">Easy Umzug Umzugsservice</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link 
                to={service.path}
                className="group block bg-white border border-neutral-200 overflow-hidden transition-shadow hover:shadow-xl h-full"
              >
                <div className="relative h-64 overflow-hidden [transform:translateZ(0)]">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    width="800"
                    height="533"
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-white">
                    <h3 className="font-heading text-xl">{service.title}</h3>
                    <div className="bg-primary p-2 rounded-full transform translate-x-4 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all">
                      <ArrowRight size={20} />
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-neutral-600 font-medium leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;